import { useState, useEffect } from "react";
// import toast from "react-hot-toast";
import { EncryptStorage } from "encrypt-storage";
import CryptoJS from "crypto-js";

export const converts = async (body) => {
  let data = JSON.stringify(body);

  let hash = CryptoJS.AES.encrypt(data, process.env.REACT_APP_KEY).toString();

  return hash;
};

export const deconverts = async (body) => {
  try {
    let bytes = CryptoJS.AES.decrypt(body, process.env.REACT_APP_KEY);
    let result = await JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

    return result;
  } catch (error) {
    return null;
  }
};

export const headers = async (body) => {
  let data = JSON.stringify(body);

  let hash = CryptoJS.HmacSHA256(data, process.env.REACT_APP_KEY);
  let signature = CryptoJS.enc.Base64.stringify(hash);

  return { "X-Signature": signature };
};

export const authsignature = async (value, body) => {
  let data = JSON.stringify(body);

  let hash = CryptoJS.HmacSHA256(data, process.env.REACT_APP_KEY);
  let signature = CryptoJS.enc.Base64.stringify(hash);
  return {
    Authorization: "Bearer " + value,
    "X-Signature": signature,
  };
};

export const authsignatureform = async (value, body) => {
  let data = JSON.stringify(body);
  let hash = CryptoJS.HmacSHA256(data, process.env.REACT_APP_KEY);
  let signature = CryptoJS.enc.Base64.stringify(hash);

  return {
    Authorization: "Bearer " + value,
    "X-Signature": signature,
    "Content-Type": "multipart/form-data",
  };
};

export const useWindowsSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });
  function handleResize() {
    // Set window width/height to state
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  }

  useEffect(() => {
    // only execute all the code below in client side
    if (typeof window !== "undefined") {
      // Handler to call on window resize
      handleResize();
      // Add event listener
      window.addEventListener("resize", handleResize);

      // Call handler right away so state gets updated with initial window size
      handleResize();

      // Remove event listener on cleanup
      return () => window.removeEventListener("resize", handleResize);
    }
  }, []); // Empty array ensures that effect is only run on mount
  return windowSize;
};

export const MoneyFormat = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  //  x.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,"); // 12,345.67
};

// export const toastSuccess = (response) => {
//   const ts = toast.success(response, {
//     duration: 4000,
//   });
//   setInterval(function () {
//     toast.dismiss(ts);
//   }, 4000);
// };

// export const toastError = (response) => {
//   const te = toast.error(response, {
//     duration: 4000,
//   });
//   setInterval(function () {
//     toast.dismiss(te);
//   }, 4000);
// };

export const setStorage = async (token) => {
  return localStorage.setItem("token", token);
};

export const getStorage = () => {
  return localStorage.getItem("token");
};

export const setStorageEmail = async (email) => {
  const encryptStorage = EncryptStorage(process.env.REACT_APP_SECRET);

  return encryptStorage.setItem("x-token", email);
};

export const getStorageEmail = async () => {
  const encryptStorage = EncryptStorage(process.env.REACT_APP_SECRET);
  const xtoken = await encryptStorage.getItem("x-token");

  return xtoken;
};

export const setStorageExp = async (expired) => {
  const encryptStorage = EncryptStorage(process.env.REACT_APP_SECRET);

  return encryptStorage.setItem("exp-token", expired);
};

export const getStorageExp = async () => {
  const encryptStorage = EncryptStorage(process.env.REACT_APP_SECRET);
  const exptoken = await encryptStorage.getItem("exp-token");

  return exptoken;
};

export const removeStorage = async () => {
  return localStorage.clear();
};

export const storage = async () => {
  const initToken = getStorage();
  const initXtoken = await getStorageEmail();

  return {
    token: initToken,
    xtoken: initXtoken,
  };
};

export const setSession = (value) => {
  return sessionStorage.setItem("checkout", value);
};

export const getSession = () => {
  return sessionStorage.getItem("checkout");
};

export const removeSession = () => {
  return sessionStorage.clear();
};

export const isEmpty = (obj) => {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
};

export const upperCase = (str) => {
  var splitStr = str.toLowerCase().split(" ");
  for (var i = 0; i < splitStr.length; i++) {
    // You do not need to check if i is larger than splitStr length, as your for does that for you
    // Assign it back to the array
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  // Directly return the joined string
  return splitStr.join(" ");
};

export const isYear = new Date().getFullYear();
